import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ChevronLeft({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M14.5858 5.29288L16 6.70709L10.7071 12L16 17.2929L14.5858 18.7071L7.87868 12L14.5858 5.29288Z"
        fill={iconColor}
      />
    </Svg>
  );
}
